// import React, { useMemo, useState, useEffect, useCallback } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { useDispatch, useSelector } from "react-redux";
// import SuggestionModal from "./suggestionMain";
// import { analyticsReport } from "../../../Redux/analytics/analytics.action";
// import "./DynamicLinkedGraphs.scss";
// import Loader from "../../../utils/loader/loader";
// import { getCodingStats } from "../../../Redux/coding/code.action";
// import CodingReport from "./CodingReport"; // ← NEW: adjust path if placed elsewhere
// import { useNavigate } from "react-router-dom";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// // ─── Palette ──────────────────────────────────────────────────────────────────
// const PALETTE = {
//   Mathematics: { solid: "#f97316", light: "#fff3e8", text: "#c2410c" },
//   Physics: { solid: "#8b5cf6", light: "#f3f0ff", text: "#6d28d9" },
//   Chemistry: { solid: "#d97706", light: "#fffbeb", text: "#b45309" },
//   Biology: { solid: "#059669", light: "#ecfdf5", text: "#065f46" },
//   English: { solid: "#0891b2", light: "#ecfeff", text: "#155e75" },
//   Science: { solid: "#db2777", light: "#fdf2f8", text: "#9d174d" },
//   "Computer science": { solid: "#2563eb", light: "#eff6ff", text: "#1e40af" },
//   "Computer Science": { solid: "#2563eb", light: "#eff6ff", text: "#1e40af" },
//   History: { solid: "#0d9488", light: "#f0fdfa", text: "#115e59" },
//   Geography: { solid: "#65a30d", light: "#f7fee7", text: "#3f6212" },
//   Hindi: { solid: "#e11d48", light: "#fff1f2", text: "#9f1239" },
//   Maths: { solid: "#f97316", light: "#fff3e8", text: "#c2410c" },
// };
// const FALLBACKS = [
//   { solid: "#7c3aed", light: "#f5f3ff", text: "#4c1d95" },
//   { solid: "#0369a1", light: "#f0f9ff", text: "#0c4a6e" },
//   { solid: "#b45309", light: "#fffbeb", text: "#78350f" },
//   { solid: "#15803d", light: "#f0fdf4", text: "#14532d" },
// ];
// const _dyn = {};
// let _fi = 0;
// function pal(sub) {
//   if (PALETTE[sub]) return PALETTE[sub];
//   if (!_dyn[sub]) {
//     _dyn[sub] = FALLBACKS[_fi % FALLBACKS.length];
//     _fi++;
//   }
//   return _dyn[sub];
// }
// function hex2rgba(hex, a) {
//   const r = parseInt(hex.slice(1, 3), 16),
//     g = parseInt(hex.slice(3, 5), 16),
//     b = parseInt(hex.slice(5, 7), 16);
//   return `rgba(${r},${g},${b},${a})`;
// }
// function toPercent(score, max) {
//   if (!max) return 0;
//   return max > 10 ? Math.min(100, score) : Math.min(100, (score / max) * 100);
// }

// // ─── Chart options ────────────────────────────────────────────────────────────
// function mkOpts({ yLabel = "", yMax, labelFn, clickFn } = {}) {
//   return {
//     responsive: true,
//     maintainAspectRatio: false,
//     animation: { duration: 500, easing: "easeOutQuart" },
//     plugins: {
//       legend: { display: false },
//       tooltip: {
//         backgroundColor: "#1e293b",
//         titleColor: "#f8fafc",
//         bodyColor: "#cbd5e1",
//         borderColor: "rgba(255,255,255,0.1)",
//         borderWidth: 1,
//         padding: 12,
//         cornerRadius: 10,
//         callbacks: { label: labelFn || ((ctx) => ` ${ctx.parsed.y}`) },
//       },
//     },
//     scales: {
//       x: {
//         grid: { display: false },
//         ticks: {
//           color: "#94a3b8",
//           font: { size: 11, family: "'DM Sans',sans-serif" },
//           maxRotation: 0,
//         },
//         border: { display: false },
//       },
//       y: {
//         min: 0,
//         max: yMax,
//         grid: { color: "rgba(0,0,0,0.05)" },
//         ticks: {
//           color: "#94a3b8",
//           font: { size: 10 },
//           callback: (v) => (yLabel ? `${v}${yLabel}` : v),
//         },
//         border: { display: false },
//       },
//     },
//     onClick: clickFn,
//   };
// }

// // ─── Score Ring ───────────────────────────────────────────────────────────────
// function ScoreRing({ score, color, size = 64, strokeWidth = 7 }) {
//   const r = (size - strokeWidth * 2) / 2;
//   const circ = 2 * Math.PI * r;
//   const dash = (score / 100) * circ;
//   return (
//     <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
//       <circle
//         cx={size / 2}
//         cy={size / 2}
//         r={r}
//         fill="none"
//         stroke={hex2rgba(color, 0.15)}
//         strokeWidth={strokeWidth}
//       />
//       <motion.circle
//         cx={size / 2}
//         cy={size / 2}
//         r={r}
//         fill="none"
//         stroke={color}
//         strokeWidth={strokeWidth}
//         strokeLinecap="round"
//         strokeDasharray={circ}
//         initial={{ strokeDashoffset: circ }}
//         animate={{ strokeDashoffset: circ - dash }}
//         transition={{ duration: 1.1, ease: "easeOut", delay: 0.1 }}
//       />
//       <text
//         x={size / 2}
//         y={size / 2 + 1}
//         textAnchor="middle"
//         dominantBaseline="middle"
//         fill="#1e293b"
//         fontSize={size > 56 ? 13 : 10}
//         fontWeight={700}
//         style={{
//           transform: `rotate(90deg)`,
//           transformOrigin: `${size / 2}px ${size / 2}px`,
//           fontFamily: "'DM Sans',sans-serif",
//         }}
//       >
//         {score}%
//       </text>
//     </svg>
//   );
// }

// // ─── Stat Card (top summary) ──────────────────────────────────────────────────
// function StatCard({ subject, score, attempts, timeSpent, active, onClick }) {
//   const p = pal(subject);
//   const dynamicStyle = {
//     background: active ? p.solid : undefined,
//     border: `1.5px solid ${active ? p.solid : "#e2e8f0"}`,
//     boxShadow: active ? `0 8px 24px ${hex2rgba(p.solid, 0.28)}` : undefined,
//   };
//   const label = subject.length > 14 ? subject.slice(0, 14) + "…" : subject;

//   return (
//     <motion.button
//       onClick={onClick}
//       whileHover={{ y: -3 }}
//       whileTap={{ scale: 0.97 }}
//       className={`dlg-stat-card${active ? " dlg-stat-card--active" : ""}`}
//       style={dynamicStyle}
//     >
//       <ScoreRing
//         score={
//           score == null
//             ? ""
//             : Number.isInteger(score)
//               ? score
//               : score.toFixed(1)
//         }
//         color={active ? "#fff" : p.solid}
//         size={48}
//         strokeWidth={5}
//       />
//       <div>
//         <div
//           className={`dlg-stat-card-label dlg-stat-card-label--${active ? "active" : "inactive"}`}
//         >
//           {label}
//         </div>
//         <div
//           className={`dlg-stat-card-score dlg-stat-card-score--${active ? "active" : "inactive"}`}
//         >
//           {score == null
//             ? ""
//             : Number.isInteger(score)
//               ? score
//               : score.toFixed(1)}
//           %
//         </div>
//         <div
//           className={`dlg-stat-card-attempts dlg-stat-card-attempts--${active ? "active" : "inactive"}`}
//         >
//           {attempts} attempt{attempts !== 1 ? "s" : ""}
//         </div>
//       </div>
//     </motion.button>
//   );
// }

// // ─── Chart Card ───────────────────────────────────────────────────────────────
// function ChartCard({
//   title,
//   subtitle,
//   height = 200,
//   accent,
//   children,
//   locked,
//   lockMsg,
//   delay = 0,
//   fullRow,
// }) {
//   return (
//     <motion.div
//       className={`dlg-card${fullRow ? " dlg-full-row" : ""}`}
//       initial={{ opacity: 0, y: 18 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ duration: 0.4, ease: "easeOut", delay }}
//     >
//       {accent && (
//         <div
//           className="dlg-card-accent"
//           style={{
//             background: `linear-gradient(90deg,${accent},${hex2rgba(accent, 0)})`,
//           }}
//         />
//       )}
//       <div className="dlg-card-header">
//         <div className="dlg-card-title">{title}</div>
//         <div className="dlg-card-sub">{subtitle}</div>
//       </div>
//       <div className="dlg-card-body" style={{ height, position: "relative"}}>
//         {children}
//       </div>
//       <AnimatePresence>
//         {locked && (
//           <motion.div
//             className="dlg-card-lock-overlay"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//           >
//             <div className="dlg-lock-icon">📊</div>
//             <span className="dlg-lock-title">Select a subject</span>
//             <span className="dlg-lock-msg">{lockMsg}</span>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </motion.div>
//   );
// }

// // ─── No Data ──────────────────────────────────────────────────────────────────
// function NoData() {
//   return (
//     <div className="dlg-no-data">
//       <svg
//         width="32"
//         height="32"
//         viewBox="0 0 24 24"
//         fill="none"
//         stroke="currentColor"
//         strokeWidth="1.2"
//       >
//         <path d="M3 3v18h18" />
//         <path d="m7 16 4-4 4 4 4-4" />
//       </svg>
//       <span className="dlg-no-data-text">No data for this period</span>
//     </div>
//   );
// }

// // ─── Period Tabs ──────────────────────────────────────────────────────────────
// const PERIODS = [
//   { val: "all", label: "All time" },
//   { val: "today", label: "Today" },
//   { val: "yesterday", label: "Yesterday" },
//   { val: "week", label: "7 days" },
//   { val: "month", label: "30 days" },
//   { val: "range", label: "Custom" },
// ];
// function PeriodTabs({ mode, onChange }) {
//   return (
//     <div className="dlg-period-tabs">
//       {PERIODS.map(({ val, label }) => (
//         <button
//           key={val}
//           onClick={() => onChange(val)}
//           className={`dlg-period-tab dlg-period-tab--${mode === val ? "active" : "inactive"}`}
//         >
//           {label}
//         </button>
//       ))}
//     </div>
//   );
// }

// // ─── Report Type Toggle ── NEW ─────────────────────────────────────────────────
// function ReportTypeToggle({ reportType, onChange }) {
//    const nav = useNavigate();
//   return (
//     <div className="dlg-report-toggle">
//       <button
//         onClick={() => onChange("assignment")}
//         className={`dlg-toggle-btn${reportType === "assignment" ? " dlg-toggle-btn--active" : ""}`}
//       >
//         Assignment
//       </button>
//       <button
//         onClick={() => {onChange("coding"); nav("/coding-report");}}
//         className={`dlg-toggle-btn${reportType === "coding" ? " dlg-toggle-btn--active" : ""}`}
//       >
//         Coding
//       </button>
//     </div>
//   );
// }

// // ─────────────────────────────────────────────────────────────────────────────
// // MAIN
// // ─────────────────────────────────────────────────────────────────────────────
// export default function DynamicLinkedGraphs() {
//   const dispatch = useDispatch();
//   const [reportType, setReportType] = useState("assignment"); // ← NEW
//   const [barThickness, setBarThickness] = useState(28);
//   const [group, setGroup] = useState("All");
//   const [topicNames, setTopicNames] = useState({});
//   const [selectedSubject, setSelectedSubject] = useState(null);
//   const [maxRawScore, setMaxRawScore] = useState(5);
//   const [section1Filter, setSection1Filter] = useState(null);
//   const [section2Filter, setSection2Filter] = useState(null);
//   const [section3Filter, setSection3Filter] = useState(null);
//   const [showCTAConfirm, setShowCTAConfirm] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState({ title: "", body: null });
//   const [mode, setMode] = useState("all");
//   const [range, setRange] = useState({ start: "", end: "" });

//   const [loading, setLoading] = useState(false);

//   const analyticsStore = useSelector(
//     (s) => s?.AnalyticsManager?.analyticsReport?.assignments,
//   );

//   useEffect(() => {
//     dispatch(analyticsReport());
//   }, [dispatch]);

//   useEffect(() => {
//     if (analyticsStore?.length > 0) processData(analyticsStore);
//   }, [analyticsStore]);

//   function processData(data) {
//     const result = {};
//     let max = 0;
//     data.forEach((item) => {
//       const sub = item.subject || "Unknown";
//       const ch = item.chapters?.[0] || "Unknown";
//       const date = (item.created_date || "").split("T")[0];
//       const score = item.score ?? 0;
//       const maxMarks = item.max_marks ?? 0;
//       const time = item.time_spent_minutes ?? 0;
//       const pct = item.percentage ?? (maxMarks ? (score / maxMarks) * 100 : 0);
//       if (score > max) max = score;
//       if (!result[sub]) result[sub] = {};
//       const key = `${ch}_${date}`;
//       if (!result[sub][key]) {
//         result[sub][key] = {
//           name: ch,
//           date,
//           score,
//           attempts: 1,
//           timeSpent: time,
//           pctSum: pct,
//         };
//       } else {
//         result[sub][key].score += score;
//         result[sub][key].attempts++;
//         result[sub][key].timeSpent += time;
//         result[sub][key].pctSum += pct;
//       }
//     });
//     Object.keys(result).forEach((sub) => {
//       result[sub] = Object.values(result[sub]).map((it) => ({
//         ...it,
//         score: it.score / it.attempts,
//         avgPercentage: it.pctSum / it.attempts,
//       }));
//     });
//     setMaxRawScore(max || 5);
//     setTopicNames(result);
//   }

//   useEffect(() => {
//     const today = new Date();
//     const iso = (d) => d.toISOString().split("T")[0];
//     const off = (n) => {
//       const d = new Date(today);
//       d.setDate(today.getDate() + n);
//       return iso(d);
//     };
//     if (mode === "today") setRange({ start: iso(today), end: iso(today) });
//     else if (mode === "yesterday") setRange({ start: off(-1), end: off(-1) });
//     else if (mode === "week") setRange({ start: off(-6), end: iso(today) });
//     else if (mode === "month") setRange({ start: off(-29), end: iso(today) });
//     else if (mode === "all") setRange({ start: "", end: "" });
//     setSection1Filter(null);
//     setSection2Filter(null);
//     setSection3Filter(null);
//     setSelectedSubject(null);
//     setGroup("All");
//   }, [mode]);

//   const filteredTopics = useMemo(() => {
//     const { start, end } = range;
//     const out = {};
//     Object.keys(topicNames).forEach((sub) => {
//       out[sub] = (topicNames[sub] || [])
//         .filter((it) => !start || !end || (it.date >= start && it.date <= end))
//         .map((it) => ({
//           topic: it.name,
//           score: it.score,
//           scoreDisplay: toPercent(it.score, maxRawScore),
//           percentage: it.avgPercentage,
//           attempts: it.attempts,
//           timeSpent: parseFloat(it.timeSpent.toFixed(1)),
//           date: it.date,
//           subject: sub,
//         }));
//     });
//     return out;
//   }, [topicNames, range, maxRawScore]);

//   const subjectsAgg = useMemo(
//     () =>
//       Object.keys(filteredTopics)
//         .map((sub) => {
//           const list = filteredTopics[sub] || [];
//           if (!list.length) return null;
//           const avgPct =
//             list.reduce((s, it) => s + (it.percentage ?? it.scoreDisplay), 0) /
//             list.length;
//           return {
//             subject: sub,
//             score: avgPct,
//             attempts: list.reduce((s, it) => s + it.attempts, 0),
//             timeSpent: parseFloat(
//               list.reduce((s, it) => s + it.timeSpent, 0).toFixed(1),
//             ),
//           };
//         })
//         .filter(Boolean),
//     [filteredTopics],
//   );

//   const topicsFlat = useMemo(
//     () => Object.values(filteredTopics).flat(),
//     [filteredTopics],
//   );

//   const overallScore = useMemo(() => {
//     if (!subjectsAgg.length) return 0;
//     return subjectsAgg.reduce((s, it) => s + it.score, 0) / subjectsAgg.length;
//   }, [subjectsAgg]);

//   const selectedScore = useMemo(
//     () =>
//       group === "All"
//         ? null
//         : (subjectsAgg.find((s) => s.subject === group)?.score ?? null),
//     [subjectsAgg, group],
//   );

//   const topicsFor = useCallback(
//     (filter) =>
//       !filter || filter === "All"
//         ? topicsFlat
//         : topicsFlat.filter((t) => t.subject === filter),
//     [topicsFlat],
//   );

//   function subjectDs(key, activeFilter) {
//     const origLabels = subjectsAgg.map((d) => d.subject);
//     return {
//       labels: subjectsAgg.map((d) =>
//         d.subject.length > 11 ? d.subject.slice(0, 11) + "…" : d.subject,
//       ),
//       _origLabels: origLabels,
//       datasets: [
//         {
//           data: subjectsAgg.map((d) => d[key]),
//           backgroundColor: subjectsAgg.map((d) => {
//             const c = pal(d.subject).solid;
//             return !activeFilter ||
//               activeFilter === "All" ||
//               d.subject === activeFilter
//               ? c
//               : hex2rgba(c, 0.2);
//           }),
//           hoverBackgroundColor: subjectsAgg.map((d) => pal(d.subject).solid),
//           borderRadius: 6,
//           borderSkipped: false,
//           barThickness,
//         },
//       ],
//     };
//   }
//   function topicDs(topics, key) {
//     return {
//       labels: topics.map((t) =>
//         t.topic?.length > 14 ? t.topic.slice(0, 14) + "…" : t.topic,
//       ),
//       datasets: [
//         {
//           data: topics.map((t) => t[key]),
//           backgroundColor: topics.map((t) => pal(t.subject).solid),
//           hoverBackgroundColor: topics.map((t) => pal(t.subject).solid),
//           borderRadius: 6,
//           borderSkipped: false,
//           barThickness,
//         },
//       ],
//     };
//   }

//   function onSubjectClick(elements, origLabels) {
//     if (!elements.length) return;
//     const sub = origLabels[elements[0].index];
//     if (selectedSubject === sub) {
//       setSelectedSubject(null);
//       setGroup("All");
//       setSection1Filter(null);
//       setSection2Filter(null);
//       setSection3Filter(null);
//     } else {
//       setSelectedSubject(sub);
//       setGroup(sub);
//       setSection1Filter(sub);
//       setSection2Filter(sub);
//       setSection3Filter(sub);
//     }
//   }

//   function confirmCTA() {
//     setShowCTAConfirm(false);
//     setModalContent({
//       title: "Suggested Plan",
//       body: (
//         <div>
//           <p style={{ marginTop: 0 }}>
//             Personalised plan for <strong>{group}</strong>:
//           </p>
//           <ul>
//             <li>Short videos + 2 practice sets</li>
//             <li>Daily 20-min focused practice</li>
//             <li>Weekly 15-min review quiz</li>
//           </ul>
//           <button
//             onClick={() => setModalOpen(false)}
//             style={{
//               padding: "9px 18px",
//               borderRadius: 8,
//               background: "#2563eb",
//               color: "#fff",
//               border: "none",
//               cursor: "pointer",
//               fontWeight: 600,
//             }}
//           >
//             Close
//           </button>
//         </div>
//       ),
//     });
//     setModalOpen(true);
//   }

//   const ds1 = subjectDs("score", section1Filter);
//   const ds2 = subjectDs("attempts", section2Filter);
//   const ds3 = subjectDs("timeSpent", section3Filter);
//   const t1 = topicsFor(section1Filter);
//   const t2 = topicsFor(section2Filter);
//   const t3 = topicsFor(section3Filter);
//   const accent = group !== "All" ? pal(group).solid : "#2563eb";

//   const totalAttempts = subjectsAgg.reduce((s, it) => s + it.attempts, 0);
//   const totalTime = subjectsAgg
//     .reduce((s, it) => s + it.timeSpent, 0)
//     .toFixed(0);

//   const CHIPS = [
//     {
//       label: "Overall",
//       value: `${
//         overallScore == null
//           ? ""
//           : Number.isInteger(overallScore)
//             ? overallScore
//             : overallScore.toFixed(1)
//       }%`,
//       icon: "🎯",
//       colorMod: "blue",
//     },
//     { label: "Attempts", value: totalAttempts, icon: "📝", colorMod: "green" },
//     { label: "Minutes", value: totalTime, icon: "⏱", colorMod: "amber" },
//   ];

//   return (
//     <div className="dlg-wrapper">
//       {/* ── Page header ── */}
//       <motion.div
//         className="dlg-page-header"
//         initial={{ opacity: 0, y: -10 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.35 }}
//       >
//         <div>
//           <h1 className="dlg-page-title">Report Board</h1>
//           <p className="dlg-page-subtitle">
//             {reportType === "assignment"
//               ? "Your learning analytics at a glance"
//               : "Your coding practice analytics at a glance"}
//           </p>
//         </div>

//         {reportType === "assignment" && (
//           <div className="dlg-summary-chips">
//             {CHIPS.map(({ label, value, icon, colorMod }) => (
//               <div key={label} className="dlg-summary-chip">
//                 <span className="dlg-chip-icon">{icon}</span>
//                 <div>
//                   <div className="dlg-chip-label">{label}</div>
//                   <div className={`dlg-chip-value dlg-chip-value--${colorMod}`}>
//                     {value}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </motion.div>

//       {/* ── Report Type Toggle ── NEW ── */}
//       <ReportTypeToggle reportType={reportType} onChange={setReportType} />

//       {/* ── Coding Report (separate component) ── NEW ── */}
//       {reportType === "coding" && <CodingReport />}

//       {/* ── Assignment Report (existing, unchanged) ── */}
//       {reportType === "assignment" && (
//         <>
//           <motion.div
//             className="dlg-controls"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.1 }}
//           >
//             <PeriodTabs mode={mode} onChange={setMode} />
//             {mode === "range" && (
//               <div className="dlg-date-range">
//                 <input
//                   type="date"
//                   value={range.start}
//                   onChange={(e) =>
//                     setRange((p) => ({ ...p, start: e.target.value }))
//                   }
//                   className="dlg-date-input"
//                 />
//                 <span className="dlg-date-range-sep">—</span>
//                 <input
//                   type="date"
//                   value={range.end}
//                   onChange={(e) =>
//                     setRange((p) => ({ ...p, end: e.target.value }))
//                   }
//                   className="dlg-date-input"
//                 />
//               </div>
//             )}
//             <div className="dlg-controls-right">
//               <span className="dlg-bar-width-label">Bar width</span>
//               <input
//                 type="range"
//                 min="10"
//                 max="60"
//                 step="2"
//                 value={barThickness}
//                 onChange={(e) => setBarThickness(Number(e.target.value))}
//                 className="dlg-range"
//               />
//               <span className="dlg-bar-width-value">{barThickness}px</span>
//             </div>
//           </motion.div>

//           {subjectsAgg.length > 0 && (
//             <motion.div
//               className="dlg-stat-cards"
//               initial={{ opacity: 0, y: 8 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.15 }}
//             >
//               {subjectsAgg.map((s) => (
//                 <StatCard
//                   key={s.subject}
//                   subject={s.subject}
//                   score={s.score}
//                   attempts={s.attempts}
//                   timeSpent={s.timeSpent}
//                   active={selectedSubject === s.subject}
//                   onClick={() =>
//                     onSubjectClick(
//                       [{ index: subjectsAgg.indexOf(s) }],
//                       subjectsAgg.map((x) => x.subject),
//                     )
//                   }
//                 />
//               ))}
//               {selectedSubject && (
//                 <motion.button
//                   className="dlg-clear-btn"
//                   initial={{ opacity: 0 }}
//                   animate={{ opacity: 1 }}
//                   onClick={() => {
//                     setSelectedSubject(null);
//                     setGroup("All");
//                     setSection1Filter(null);
//                     setSection2Filter(null);
//                     setSection3Filter(null);
//                   }}
//                 >
//                   ✕ Clear
//                 </motion.button>
//               )}
//             </motion.div>
//           )}

//           <div className="dlg-grid">
//             <ChartCard
//               title="Subject Scores"
//               subtitle="Click a bar to explore topics"
//               accent="#2563eb"
//               delay={0.18}
//             >
//               {subjectsAgg.length === 0 ? (
//                 <NoData />
//               ) : (
//                 <Bar
//                   data={ds1}
//                   options={mkOpts({
//                     yLabel: "%",
//                     yMax: 100,
//                     labelFn: (ctx) =>
//                       `Avg. ${
//                         Number.isInteger(ctx.parsed.y)
//                           ? ctx.parsed.y
//                           : ctx.parsed.y.toFixed(1)
//                       }%`,
//                     clickFn: (_, els) => onSubjectClick(els, ds1._origLabels),
//                   })}
//                 />
//               )}
//             </ChartCard>

//             <ChartCard
//               title="Topic Scores"
//               subtitle={
//                 selectedSubject
//                   ? `${selectedSubject} — breakdown`
//                   : "Select a subject first"
//               }
//               accent={accent}
//               delay={0.22}
//               locked={group === "All"}
//               lockMsg="Click a subject card above"
//             >
//               {t1.length === 0 ? (
//                 <NoData />
//               ) : (
//                 <Bar
//                   data={topicDs(t1, "percentage")}
//                   options={mkOpts({
//                     yLabel: "%",
//                     yMax: 100,
//                     labelFn: (ctx) =>
//                       `Avg. ${
//                         Number.isInteger(ctx.parsed.y)
//                           ? ctx.parsed.y
//                           : ctx.parsed.y.toFixed(1)
//                       }%`,
//                   })}
//                 />
//               )}
//             </ChartCard>

//             {/* AI full-row card */}
//             <motion.div
//               className="dlg-ai-card dlg-full-row"
//               initial={{ opacity: 0, y: 16 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.28 }}
//             >
//               <div className="dlg-ai-inner">
//                 <div className="dlg-ai-icon">✦</div>
//                 <div className="dlg-ai-content">
//                   <div className="dlg-ai-title">AI Insight</div>
//                   <div className="dlg-ai-body">
//                     {group === "All"
//                       ? `Overall score ${overallScore}% across ${subjectsAgg.length} subject${subjectsAgg.length !== 1 ? "s" : ""}. ${overallScore >= 70 ? "Great progress! Keep the momentum going." : "Consistent daily practice will help push scores higher."}`
//                       : `${group} score is ${selectedScore}%. Focus on weaker topics and reduce time on areas you've already mastered.`}
//                   </div>
//                 </div>
//                 <motion.button
//                   className="dlg-ai-cta"
//                   whileHover={{ scale: 1.04 }}
//                   whileTap={{ scale: 0.97 }}
//                   onClick={() => setShowCTAConfirm(true)}
//                 >
//                   Explore Course →
//                 </motion.button>
//               </div>
//             </motion.div>

//             <ChartCard
//               title="Attempts"
//               subtitle="Total attempts per subject"
//               accent="#db2777"
//               delay={0.32}
//             >
//               {subjectsAgg.length === 0 ? (
//                 <NoData />
//               ) : (
//                 <Bar
//                   data={ds2}
//                   options={mkOpts({
//                     labelFn: (ctx) => ` ${ctx.parsed.y} attempts`,
//                     clickFn: (_, els) => {
//                       if (!els.length) return;
//                       const sub = ds2._origLabels[els[0].index];
//                       setSection2Filter(section2Filter === sub ? null : sub);
//                     },
//                   })}
//                 />
//               )}
//             </ChartCard>

//             <ChartCard
//               title="Topic Attempts"
//               subtitle={
//                 section2Filter
//                   ? `${section2Filter} breakdown`
//                   : "Select a subject"
//               }
//               accent={section2Filter ? pal(section2Filter).solid : "#db2777"}
//               delay={0.36}
//               locked={group === "All"}
//               lockMsg="Click a subject card to see topic attempts"
//             >
//               {t2.length === 0 ? (
//                 <NoData />
//               ) : (
//                 <Bar
//                   data={topicDs(t2, "attempts")}
//                   options={mkOpts({
//                     labelFn: (ctx) => ` ${ctx.parsed.y} attempts`,
//                   })}
//                 />
//               )}
//             </ChartCard>

//             <ChartCard
//               title="Time Spent"
//               subtitle="Total minutes per subject"
//               accent="#059669"
//               delay={0.4}
//               height={180}
//             >
//               {subjectsAgg.length === 0 ? (
//                 <NoData />
//               ) : (
//                 <Bar
//                   data={ds3}
//                   options={mkOpts({
//                     yLabel: "m",
//                     labelFn: (ctx) => ` ${ctx.parsed.y} min`,
//                     clickFn: (_, els) => {
//                       if (!els.length) return;
//                       const sub = ds3._origLabels[els[0].index];
//                       setSection3Filter(section3Filter === sub ? null : sub);
//                     },
//                   })}
//                 />
//               )}
//             </ChartCard>

//             <ChartCard
//               title="Time per Topic"
//               subtitle={
//                 section3Filter
//                   ? `${section3Filter} breakdown`
//                   : "Select a subject"
//               }
//               accent={section3Filter ? pal(section3Filter).solid : "#059669"}
//               delay={0.44}
//               height={180}
//               locked={group === "All"}
//               lockMsg="Click a subject card to see time per topic"
//             >
//               {t3.length === 0 ? (
//                 <NoData />
//               ) : (
//                 <Bar
//                   data={topicDs(t3, "timeSpent")}
//                   options={mkOpts({
//                     yLabel: "m",
//                     labelFn: (ctx) => ` ${ctx.parsed.y} min`,
//                   })}
//                 />
//               )}
//             </ChartCard>
//           </div>

//           {/* ── CTA confirm modal ── */}
//           <AnimatePresence>
//             {showCTAConfirm && (
//               <motion.div
//                 className="dlg-modal-backdrop"
//                 initial={{ opacity: 0 }}
//                 animate={{ opacity: 1 }}
//                 exit={{ opacity: 0 }}
//                 onClick={() => setShowCTAConfirm(false)}
//               >
//                 <motion.div
//                   className="dlg-modal-box"
//                   initial={{ scale: 0.88, y: 20 }}
//                   animate={{ scale: 1, y: 0 }}
//                   exit={{ scale: 0.88, y: 20 }}
//                   onClick={(e) => e.stopPropagation()}
//                 >
//                   <div className="dlg-modal-title">Ready to start?</div>
//                   <p className="dlg-modal-body">
//                     Open personalised course suggestions for{" "}
//                     <strong style={{ color: "#1e293b" }}>{group}</strong>.
//                   </p>
//                   <div className="dlg-modal-actions">
//                     <button className="dlg-modal-confirm" onClick={confirmCTA}>
//                       Confirm
//                     </button>
//                     <button
//                       className="dlg-modal-cancel"
//                       onClick={() => setShowCTAConfirm(false)}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                 </motion.div>
//               </motion.div>
//             )}
//           </AnimatePresence>

//           <SuggestionModal
//             open={modalOpen}
//             title={modalContent.title}
//             onClose={() => setModalOpen(false)}
//           >
//             {modalContent.body}
//           </SuggestionModal>
//           <Loader show={loading} />
//         </>
//       )}
//     </div>
//   );
// }

import React, { useMemo, useState, useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import SuggestionModal from "./suggestionMain";
import { analyticsReport } from "../../../Redux/analytics/analytics.action";
import "./DynamicLinkedGraphs.scss";
import Loader from "../../../utils/loader/loader";
import { getCodingStats } from "../../../Redux/coding/code.action";
import CodingReport from "./CodingReport";
import { useNavigate } from "react-router-dom";

import {
  pal,
  hex2rgba,
  toPercent,
  mkOpts,
  ScoreRing,
  StatCard,
  ChartCard,
  NoData,
  PeriodTabs,
} from "../../../Reusable_Components/Report";


ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

// ─── Report Type Toggle ── (unique to this file, not shared) ─────────────────
function ReportTypeToggle({ reportType, onChange }) {
  const nav = useNavigate();
  return (
    <div className="dlg-report-toggle">
      <button
        onClick={() => onChange("assignment")}
        className={`dlg-toggle-btn${reportType === "assignment" ? " dlg-toggle-btn--active" : ""}`}
      >
        Assignment
      </button>
      <button
        // onClick={() => {
        //   onChange("coding");
        //   nav("/coding-report");
        // }}
        onClick={() => onChange("coding")}
        className={`dlg-toggle-btn${reportType === "coding" ? " dlg-toggle-btn--active" : ""}`}
      >
        Coding
      </button>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// MAIN
// ─────────────────────────────────────────────────────────────────────────────
export default function DynamicLinkedGraphs() {
  const dispatch = useDispatch();
  const [reportType, setReportType] = useState("assignment"); // ← NEW
  const [barThickness, setBarThickness] = useState(28);
  const [group, setGroup] = useState("All");
  const [topicNames, setTopicNames] = useState({});
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [maxRawScore, setMaxRawScore] = useState(5);
  const [section1Filter, setSection1Filter] = useState(null);
  const [section2Filter, setSection2Filter] = useState(null);
  const [section3Filter, setSection3Filter] = useState(null);
  const [showCTAConfirm, setShowCTAConfirm] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ title: "", body: null });
  const [mode, setMode] = useState("all");
  const [range, setRange] = useState({ start: "", end: "" });

  const [loading, setLoading] = useState(false);

  const analyticsStore = useSelector(
    (s) => s?.AnalyticsManager?.analyticsReport?.assignments,
  );

  useEffect(() => {
    dispatch(analyticsReport());
  }, [dispatch]);

  useEffect(() => {
    if (analyticsStore?.length > 0) processData(analyticsStore);
  }, [analyticsStore]);

  function processData(data) {
    const result = {};
    let max = 0;
    data.forEach((item) => {
      const sub = item.subject || "Unknown";
      const ch = item.chapters?.[0] || "Unknown";
      const date = (item.created_date || "").split("T")[0];
      const score = item.score ?? 0;
      const maxMarks = item.max_marks ?? 0;
      const time = item.time_spent_minutes ?? 0;
      const pct = item.percentage ?? (maxMarks ? (score / maxMarks) * 100 : 0);
      if (score > max) max = score;
      if (!result[sub]) result[sub] = {};
      const key = `${ch}_${date}`;
      if (!result[sub][key]) {
        result[sub][key] = {
          name: ch,
          date,
          score,
          attempts: 1,
          timeSpent: time,
          pctSum: pct,
        };
      } else {
        result[sub][key].score += score;
        result[sub][key].attempts++;
        result[sub][key].timeSpent += time;
        result[sub][key].pctSum += pct;
      }
    });
    Object.keys(result).forEach((sub) => {
      result[sub] = Object.values(result[sub]).map((it) => ({
        ...it,
        score: it.score / it.attempts,
        avgPercentage: it.pctSum / it.attempts,
      }));
    });
    setMaxRawScore(max || 5);
    setTopicNames(result);
  }

  useEffect(() => {
    const today = new Date();
    const iso = (d) => d.toISOString().split("T")[0];
    const off = (n) => {
      const d = new Date(today);
      d.setDate(today.getDate() + n);
      return iso(d);
    };
    if (mode === "today") setRange({ start: iso(today), end: iso(today) });
    else if (mode === "yesterday") setRange({ start: off(-1), end: off(-1) });
    else if (mode === "week") setRange({ start: off(-6), end: iso(today) });
    else if (mode === "month") setRange({ start: off(-29), end: iso(today) });
    else if (mode === "all") setRange({ start: "", end: "" });
    setSection1Filter(null);
    setSection2Filter(null);
    setSection3Filter(null);
    setSelectedSubject(null);
    setGroup("All");
  }, [mode]);

  const filteredTopics = useMemo(() => {
    const { start, end } = range;
    const out = {};
    Object.keys(topicNames).forEach((sub) => {
      out[sub] = (topicNames[sub] || [])
        .filter((it) => !start || !end || (it.date >= start && it.date <= end))
        .map((it) => ({
          topic: it.name,
          score: it.score,
          scoreDisplay: toPercent(it.score, maxRawScore),
          percentage: it.avgPercentage,
          attempts: it.attempts,
          timeSpent: parseFloat(it.timeSpent.toFixed(1)),
          date: it.date,
          subject: sub,
        }));
    });
    return out;
  }, [topicNames, range, maxRawScore]);

  const subjectsAgg = useMemo(
    () =>
      Object.keys(filteredTopics)
        .map((sub) => {
          const list = filteredTopics[sub] || [];
          if (!list.length) return null;
          const avgPct =
            list.reduce((s, it) => s + (it.percentage ?? it.scoreDisplay), 0) /
            list.length;
          return {
            subject: sub,
            score: avgPct,
            attempts: list.reduce((s, it) => s + it.attempts, 0),
            timeSpent: parseFloat(
              list.reduce((s, it) => s + it.timeSpent, 0).toFixed(1),
            ),
          };
        })
        .filter(Boolean),
    [filteredTopics],
  );

  const topicsFlat = useMemo(
    () => Object.values(filteredTopics).flat(),
    [filteredTopics],
  );

  const overallScore = useMemo(() => {
    if (!subjectsAgg.length) return 0;
    return subjectsAgg.reduce((s, it) => s + it.score, 0) / subjectsAgg.length;
  }, [subjectsAgg]);

  const selectedScore = useMemo(
    () =>
      group === "All"
        ? null
        : (subjectsAgg.find((s) => s.subject === group)?.score ?? null),
    [subjectsAgg, group],
  );

  const topicsFor = useCallback(
    (filter) =>
      !filter || filter === "All"
        ? topicsFlat
        : topicsFlat.filter((t) => t.subject === filter),
    [topicsFlat],
  );

  function subjectDs(key, activeFilter) {
    const origLabels = subjectsAgg.map((d) => d.subject);
    return {
      labels: subjectsAgg.map((d) =>
        d.subject.length > 11 ? d.subject.slice(0, 11) + "…" : d.subject,
      ),
      _origLabels: origLabels,
      datasets: [
        {
          data: subjectsAgg.map((d) => d[key]),
          backgroundColor: subjectsAgg.map((d) => {
            const c = pal(d.subject).solid;
            return !activeFilter ||
              activeFilter === "All" ||
              d.subject === activeFilter
              ? c
              : hex2rgba(c, 0.2);
          }),
          hoverBackgroundColor: subjectsAgg.map((d) => pal(d.subject).solid),
          borderRadius: 6,
          borderSkipped: false,
          barThickness,
        },
      ],
    };
  }
  function topicDs(topics, key) {
    return {
      labels: topics.map((t) =>
        t.topic?.length > 14 ? t.topic.slice(0, 14) + "…" : t.topic,
      ),
      datasets: [
        {
          data: topics.map((t) => t[key]),
          backgroundColor: topics.map((t) => pal(t.subject).solid),
          hoverBackgroundColor: topics.map((t) => pal(t.subject).solid),
          borderRadius: 6,
          borderSkipped: false,
          barThickness,
        },
      ],
    };
  }

  function onSubjectClick(elements, origLabels) {
    if (!elements.length) return;
    const sub = origLabels[elements[0].index];
    if (selectedSubject === sub) {
      setSelectedSubject(null);
      setGroup("All");
      setSection1Filter(null);
      setSection2Filter(null);
      setSection3Filter(null);
    } else {
      setSelectedSubject(sub);
      setGroup(sub);
      setSection1Filter(sub);
      setSection2Filter(sub);
      setSection3Filter(sub);
    }
  }

  function confirmCTA() {
    setShowCTAConfirm(false);
    setModalContent({
      title: "Suggested Plan",
      body: (
        <div>
          <p style={{ marginTop: 0 }}>
            Personalised plan for <strong>{group}</strong>:
          </p>
          <ul>
            <li>Short videos + 2 practice sets</li>
            <li>Daily 20-min focused practice</li>
            <li>Weekly 15-min review quiz</li>
          </ul>
          <button
            onClick={() => setModalOpen(false)}
            style={{
              padding: "9px 18px",
              borderRadius: 8,
              background: "#2563eb",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Close
          </button>
        </div>
      ),
    });
    setModalOpen(true);
  }

  const ds1 = subjectDs("score", section1Filter);
  const ds2 = subjectDs("attempts", section2Filter);
  const ds3 = subjectDs("timeSpent", section3Filter);
  const t1 = topicsFor(section1Filter);
  const t2 = topicsFor(section2Filter);
  const t3 = topicsFor(section3Filter);
  const accent = group !== "All" ? pal(group).solid : "#2563eb";

  const totalAttempts = subjectsAgg.reduce((s, it) => s + it.attempts, 0);
  const totalTime = subjectsAgg
    .reduce((s, it) => s + it.timeSpent, 0)
    .toFixed(0);

  const CHIPS = [
    {
      label: "Overall",
      value: `${
        overallScore == null
          ? ""
          : Number.isInteger(overallScore)
            ? overallScore
            : overallScore.toFixed(1)
      }%`,
      icon: "🎯",
      colorMod: "blue",
    },
    { label: "Attempts", value: totalAttempts, icon: "📝", colorMod: "green" },
    { label: "Minutes", value: totalTime, icon: "⏱", colorMod: "amber" },
  ];

  return (
    <div className="dlg-wrapper">
      {/* ── Page header ── */}
      <motion.div
        className="dlg-page-header"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        <div>
          <h1 className="dlg-page-title">Report Board</h1>
          <p className="dlg-page-subtitle">
            {reportType === "assignment"
              ? "Your learning analytics at a glance"
              : "Your coding practice analytics at a glance"}
          </p>
        </div>

        {reportType === "assignment" && (
          <div className="dlg-summary-chips">
            {CHIPS.map(({ label, value, icon, colorMod }) => (
              <div key={label} className="dlg-summary-chip">
                <span className="dlg-chip-icon">{icon}</span>
                <div>
                  <div className="dlg-chip-label">{label}</div>
                  <div className={`dlg-chip-value dlg-chip-value--${colorMod}`}>
                    {value}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </motion.div>

      {/* ── Report Type Toggle ── NEW ── */}
      <ReportTypeToggle reportType={reportType} onChange={setReportType} />

      {/* ── Coding Report (separate component) ── NEW ── */}
      {reportType === "coding" && <CodingReport />}

      {/* ── Assignment Report (existing, unchanged) ── */}
      {reportType === "assignment" && (
        <>
          <motion.div
            className="dlg-controls"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.1 }}
          >
            <PeriodTabs mode={mode} onChange={setMode} />
            {mode === "range" && (
              <div className="dlg-date-range">
                <input
                  type="date"
                  value={range.start}
                  onChange={(e) =>
                    setRange((p) => ({ ...p, start: e.target.value }))
                  }
                  className="dlg-date-input"
                />
                <span className="dlg-date-range-sep">—</span>
                <input
                  type="date"
                  value={range.end}
                  onChange={(e) =>
                    setRange((p) => ({ ...p, end: e.target.value }))
                  }
                  className="dlg-date-input"
                />
              </div>
            )}
            <div className="dlg-controls-right">
              <span className="dlg-bar-width-label">Bar width</span>
              <input
                type="range"
                min="10"
                max="60"
                step="2"
                value={barThickness}
                onChange={(e) => setBarThickness(Number(e.target.value))}
                className="dlg-range"
              />
              <span className="dlg-bar-width-value">{barThickness}px</span>
            </div>
          </motion.div>

          {subjectsAgg.length > 0 && (
            <motion.div
              className="dlg-stat-cards"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15 }}
            >
              {subjectsAgg.map((s) => (
                <StatCard
                  key={s.subject}
                  subject={s.subject}
                  score={s.score}
                  attempts={s.attempts}
                  timeSpent={s.timeSpent}
                  active={selectedSubject === s.subject}
                  onClick={() =>
                    onSubjectClick(
                      [{ index: subjectsAgg.indexOf(s) }],
                      subjectsAgg.map((x) => x.subject),
                    )
                  }
                />
              ))}
              {selectedSubject && (
                <motion.button
                  className="dlg-clear-btn"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  onClick={() => {
                    setSelectedSubject(null);
                    setGroup("All");
                    setSection1Filter(null);
                    setSection2Filter(null);
                    setSection3Filter(null);
                  }}
                >
                  ✕ Clear
                </motion.button>
              )}
            </motion.div>
          )}

          <div className="dlg-grid">
            <ChartCard
              title="Subject Scores"
              subtitle="Click a bar to explore topics"
              accent="#2563eb"
              delay={0.18}
            >
              {subjectsAgg.length === 0 ? (
                <NoData />
              ) : (
                <Bar
                  data={ds1}
                  options={mkOpts({
                    yLabel: "%",
                    yMax: 100,
                    maxRotation: 0,
                    labelFn: (ctx) =>
                      `Avg. ${
                        Number.isInteger(ctx.parsed.y)
                          ? ctx.parsed.y
                          : ctx.parsed.y.toFixed(1)
                      }%`,
                    clickFn: (_, els) => onSubjectClick(els, ds1._origLabels),
                  })}
                />
              )}
            </ChartCard>

            <ChartCard
              title="Topic Scores"
              subtitle={
                selectedSubject
                  ? `${selectedSubject} — breakdown`
                  : "Select a subject first"
              }
              accent={accent}
              delay={0.22}
              locked={group === "All"}
              lockMsg="Click a subject card above"
            >
              {t1.length === 0 ? (
                <NoData />
              ) : (
                <Bar
                  data={topicDs(t1, "percentage")}
                  options={mkOpts({
                    yLabel: "%",
                    yMax: 100,
                    maxRotation: 0,
                    labelFn: (ctx) =>
                      `Avg. ${
                        Number.isInteger(ctx.parsed.y)
                          ? ctx.parsed.y
                          : ctx.parsed.y.toFixed(1)
                      }%`,
                  })}
                />
              )}
            </ChartCard>

            {/* AI full-row card */}
            <motion.div
              className="dlg-ai-card dlg-full-row"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.28 }}
            >
              <div className="dlg-ai-inner">
                <div className="dlg-ai-icon">✦</div>
                <div className="dlg-ai-content">
                  <div className="dlg-ai-title">AI Insight</div>
                  <div className="dlg-ai-body">
                    {group === "All"
                      ? `Overall score ${overallScore}% across ${subjectsAgg.length} subject${subjectsAgg.length !== 1 ? "s" : ""}. ${overallScore >= 70 ? "Great progress! Keep the momentum going." : "Consistent daily practice will help push scores higher."}`
                      : `${group} score is ${selectedScore}%. Focus on weaker topics and reduce time on areas you've already mastered.`}
                  </div>
                </div>
                <motion.button
                  className="dlg-ai-cta"
                  whileHover={{ scale: 1.04 }}
                  whileTap={{ scale: 0.97 }}
                  onClick={() => setShowCTAConfirm(true)}
                >
                  Explore Course →
                </motion.button>
              </div>
            </motion.div>

            <ChartCard
              title="Attempts"
              subtitle="Total attempts per subject"
              accent="#db2777"
              delay={0.32}
            >
              {subjectsAgg.length === 0 ? (
                <NoData />
              ) : (
                <Bar
                  data={ds2}
                  options={mkOpts({
                    maxRotation: 0,
                    labelFn: (ctx) => ` ${ctx.parsed.y} attempts`,
                    clickFn: (_, els) => {
                      if (!els.length) return;
                      const sub = ds2._origLabels[els[0].index];
                      setSection2Filter(section2Filter === sub ? null : sub);
                    },
                  })}
                />
              )}
            </ChartCard>

            <ChartCard
              title="Topic Attempts"
              subtitle={
                section2Filter
                  ? `${section2Filter} breakdown`
                  : "Select a subject"
              }
              accent={section2Filter ? pal(section2Filter).solid : "#db2777"}
              delay={0.36}
              locked={group === "All"}
              lockMsg="Click a subject card to see topic attempts"
            >
              {t2.length === 0 ? (
                <NoData />
              ) : (
                <Bar
                  data={topicDs(t2, "attempts")}
                  options={mkOpts({
                    maxRotation: 0,
                    labelFn: (ctx) => ` ${ctx.parsed.y} attempts`,
                  })}
                />
              )}
            </ChartCard>

            <ChartCard
              title="Time Spent"
              subtitle="Total minutes per subject"
              accent="#059669"
              delay={0.4}
              height={180}
            >
              {subjectsAgg.length === 0 ? (
                <NoData />
              ) : (
                <Bar
                  data={ds3}
                  options={mkOpts({
                    yLabel: "m",
                    maxRotation: 0,
                    labelFn: (ctx) => ` ${ctx.parsed.y} min`,
                    clickFn: (_, els) => {
                      if (!els.length) return;
                      const sub = ds3._origLabels[els[0].index];
                      setSection3Filter(section3Filter === sub ? null : sub);
                    },
                  })}
                />
              )}
            </ChartCard>

            <ChartCard
              title="Time per Topic"
              subtitle={
                section3Filter
                  ? `${section3Filter} breakdown`
                  : "Select a subject"
              }
              accent={section3Filter ? pal(section3Filter).solid : "#059669"}
              delay={0.44}
              height={180}
              locked={group === "All"}
              lockMsg="Click a subject card to see time per topic"
            >
              {t3.length === 0 ? (
                <NoData />
              ) : (
                <Bar
                  data={topicDs(t3, "timeSpent")}
                  options={mkOpts({
                    yLabel: "m",
                    maxRotation: 0,
                    labelFn: (ctx) => ` ${ctx.parsed.y} min`,
                  })}
                />
              )}
            </ChartCard>
          </div>

          {/* ── CTA confirm modal ── */}
          <AnimatePresence>
            {showCTAConfirm && (
              <motion.div
                className="dlg-modal-backdrop"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setShowCTAConfirm(false)}
              >
                <motion.div
                  className="dlg-modal-box"
                  initial={{ scale: 0.88, y: 20 }}
                  animate={{ scale: 1, y: 0 }}
                  exit={{ scale: 0.88, y: 20 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="dlg-modal-title">Ready to start?</div>
                  <p className="dlg-modal-body">
                    Open personalised course suggestions for{" "}
                    <strong style={{ color: "#1e293b" }}>{group}</strong>.
                  </p>
                  <div className="dlg-modal-actions">
                    <button className="dlg-modal-confirm" onClick={confirmCTA}>
                      Confirm
                    </button>
                    <button
                      className="dlg-modal-cancel"
                      onClick={() => setShowCTAConfirm(false)}
                    >
                      Cancel
                    </button>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

          <SuggestionModal
            open={modalOpen}
            title={modalContent.title}
            onClose={() => setModalOpen(false)}
          >
            {modalContent.body}
          </SuggestionModal>
          <Loader show={loading} />
        </>
      )}
    </div>
  );
}